import * as selectors from './selectors'
import subleaseSaga from './sagas'
import slice from './reducer'

export const {
  fetchSubleaseList,
  fetchSubleaseListSuccess,
  fetchSubleaseListFailed,
  updateFilters,

  fetchSubleaseDetails: subleaseDetailsRequested,
  fetchSubleaseDetailsSuccess: subleaseDetailsSuccess,
  fetchSubleaseDetailsFailed: subleaseDetailsFailed,

  resetSubleaseDetails,
  fetchHistoricalTenantsRequested: subleaseHistoricalTenantsRequested,
  fetchHistoricalTenantsSuccess: subleaseHistoricalTenantsSuccess,
  fetchHistoricalTenantsFailed: subleaseHistoricalTenantsFailed,

  addSubleaseDecisionRequested,
  addSubleaseDecisionSuccess,
  addSubleaseDecisionFailed,

  undoSubleaseDecisionRequested,
  undoSubleaseDecisionSuccess,
  undoSubleaseDecisionFailed,

  clearProcessingError,

  updateEndDateRequested,
  updateEndDateSuccess,
  updateEndDateFailed,

  fetchSubleaseSettingsRequested,
  fetchSubleaseSettingsSuccess,
  fetchSubleaseSettingsFailed,
} = slice.actions

export default slice.reducer

export { selectors }
export { subleaseSaga }
